<template>
  <div>
    <div class="zhb fp" v-if="this.$store.state.productLoading">
      <not-available v-if="getList.length === 0" title="移动风险感知平台">
        <div class="product-introduce">
          <p
            class="bottom"
          >移动互联网时代的到来，移动端应用爆发式增长，与此同时，黑灰产也逐步把注意力从PC端转移到移动端，导致移动端面临的安全威胁种类和数量在不断增长，系统漏洞、软件漏洞、业务逻辑漏洞、虚假设备、协议伪造、真人众包等等攻击手段层出不穷，使企业蒙受直接的经济和口碑的损失，同时也严重威胁用户的隐私和资金安全。</p>
          <p>
            <span class="product">移动风险感知平台</span>通过在移动应用中植入风险感知SDK，在应用运行过程中的采集信息，然后结合后台“决策引擎”规则判定，实时检测出移动应用运行中的风险因素，规避黑灰产欺诈场景。
          </p>
        </div>
      </not-available>
      <div v-if="getList.length > 0">
        <table class="pTable">
          <thead>
            <tr>
              <th>
                <p>产品</p>
              </th>
              <th>
                <p>开通时间</p>
              </th>
              <th>
                <p>截止时间</p>
              </th>
              <th>
                <p>购买次数</p>
              </th>
              <th>
                <p>剩余次数</p>
              </th>
              <th>
                <p>状态</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item,index) in $store.state.product"
              v-show="item.auditflag=='5' && item.busi === 'antifraud_online'"
              :key="index"
            >
              <td>
                <p>{{productName(item)}}</p>
              </td>
              <td>
                <p>{{item.ctime}}</p>
              </td>
              <td>
                <p>{{item.expire}}</p>
              </td>
              <td>
                <p v-if="item.busi.includes('offline')">-</p>
                <p v-else>{{toThousands(item.reqtotal)}}次</p>
              </td>
              <td>
                <p v-if="item.busi.includes('offline')">-</p>
                <p v-else>{{toThousands(item.reqtotal - item.reqused)}}次</p>
              </td>
              <td>
                <p>{{rank(item.auditflag)}}</p>
              </td>
            </tr>
          </tbody>
        </table>
        <h2
          style="padding: 20px 0 7px;font-size: 18px;
    color: rgba(111,118,140,1);font-weight: 500;"
        >全量访问统计</h2>
        <div style="margin-bottom: 10px;display: flex;">
          <el-radio-group v-model="radio" size="small" @change="radioChange">
            <el-radio-button label="当天"></el-radio-button>
            <el-radio-button label="最近7天"></el-radio-button>
            <el-radio-button label="最近30天"></el-radio-button>
            <el-radio-button label="自定义"></el-radio-button>
          </el-radio-group>
          <div
            class="block"
            v-if="custom"
            style="margin-left: 20px;transition: 2s all ease-in-out; "
          >
            <el-date-picker
              size="small"
              v-model="value"
              @change="timeChange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>
        </div>
        <fingerprint :data="data" :dataCoord="dataCoord" :loading="loading" :tag="tag"></fingerprint>
        <select-list></select-list>
      </div>
    </div>
    <loading v-if="!this.$store.state.productLoading"></loading>
  </div>
</template>
<script>
import { getFingerPrintAggregate } from '../../services/interface'
import notAvailable from '../../components/mark/notAvailable'
import { toThousands } from '../../util/common'
import fingerprint from '../../components/chart/fingerprint'
import selectList from './components/selectList'
import moment from 'moment'

export default {
  components: {
    fingerprint,
    selectList,
    notAvailable
  },
  data () {
    return {
      activeName: 'first',
      type: null,
      list: [
        {
          label: '移动风险感知平台',
          value: 'antifraud_online'
        }
      ],
      modalStatus: {
        applyModal: false,
        successModal: false,
        connectModal: false
      },
      isCopy: false,
      copyText: '',
      tip: '',
      dis: false,
      radio: '最近30天',
      tag: false,
      value: '',
      custom: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() || time.getTime() < Date.now() - 7776000000
        }
      },
      data: [],
      dataCoord: [],
      loading: true
    }
  },
  mounted () {
    if (this.data.length === 0) {
      const nowTime = new Date()
      const endTime = moment(nowTime)
      const startTime = moment(nowTime).subtract(30, 'days')
      this.getChartData(startTime, endTime, 24, 'MM-DD')
    }
    // this.getData()
  },
  methods: {
    toThousands,
    rank (k) {
      if (k === '5') {
        return '使用中'
      } else if (k === '1') {
        return '待付款'
      } else if (k === '2') {
        return '待审核'
      } else if (k === '4') {
        return '已失效'
      } else {
        return '其他状态'
      }
    },
    productName (item) {
      switch (item.busi) {
        case 'antifraud_online':
          return '移动风险感知平台'
        case 'antifraud_offline':
          return '智能反欺诈引擎-本地化部署'
        case 'heika_online':
          return '手机号画像-SaaS版'
        case 'heika_offline':
          return '手机号画像-本地化部署'
        case 'blackipv2_online':
          return 'IP画像-SaaS版'
        case 'blackipv2_offline':
          return 'IP画像-本地化部署'
      }
    },
    timeChange (val) {
      const endTime = moment(val[1])
      const startTime = moment(val[0])
      console.log(endTime)
      if (endTime.diff(startTime, 'days') > 0) {
        this.getChartData(startTime, endTime, 24, 'MM-DD')
      } else {
        this.getChartData(startTime, endTime, 1, 'MM-DD HH:00')
      }
    },
    handleClick (tab, event) {
      if (tab.name === 'second') {
        if (this.data.length === 0) {
          const nowTime = new Date()
          const endTime = moment(nowTime)
          const startTime = moment(nowTime).subtract(30, 'days')
          this.getChartData(startTime, endTime, 24, 'MM-DD')
        }
      }
    },
    radioChange (val) {
      let nowTime, endTime, startTime, weeklyTime, endweeklyTime,
        startweeklyTime, monthTime, endmonthTime, startmonthTime,
        endCustomTime, startCustomTime
      switch (val) {
        case '当天':
          nowTime = new Date()
          endTime = moment(nowTime)
          startTime = moment(nowTime).subtract(1, 'days')
          this.getChartData(startTime, endTime, 1, 'MM-DD HH:00')
          this.custom = false
          break
        case '最近7天':
          weeklyTime = new Date()
          endweeklyTime = moment(weeklyTime)
          startweeklyTime = moment(weeklyTime).subtract(7, 'days')
          this.getChartData(startweeklyTime, endweeklyTime, 24, 'MM-DD')
          this.custom = false
          break
        case '最近30天':
          monthTime = new Date()
          endmonthTime = moment(monthTime)
          startmonthTime = moment(monthTime).subtract(30, 'days')
          this.getChartData(startmonthTime, endmonthTime, 24, 'MM-DD')
          this.custom = false
          break
        case '自定义':
          this.custom = true
          if (!this.value) {
            this.tag = true
            break
          }
          endCustomTime = moment(this.value[1])
          startCustomTime = moment(this.value[0])
          if (endCustomTime.diff(startCustomTime, 'days') > 0) {
            this.getChartData(startCustomTime, endCustomTime, 24, 'MM-DD')
          } else {
            this.getChartData(startCustomTime, endCustomTime, 1, 'MM-DD HH:00')
          }
          break
      }
    },
    async getChartData (startTime, endTime, step, lay) {
      this.loading = true
      const data1 = {
        start_time: startTime.toISOString(),
        end_time: endTime.toISOString(),
        step: step
      }
      const res = await getFingerPrintAggregate(data1)
      const myData = []
      for (const point of res.data.data) {
        myData.push({
          date: moment(point.time).format(lay),
          name: '高风险次数',
          value: point.high_level_count
        })
        myData.push({
          date: moment(point.time).format(lay),
          name: '中风险次数',
          value: point.middle_level_count
        })
        myData.push({
          date: moment(point.time).format(lay),
          name: '低风险次数',
          value: point.low_level_count
        })
        myData.push({
          date: moment(point.time).format(lay),
          name: '查询总次数',
          value: point.total_count
        })
      }
      const myDataCoord = []
      let high = 0
      let middle = 0
      // eslint-disable-next-line no-unused-vars
      let low = 0
      let total = 0
      for (const val of res.data.data) {
        high += val.high_level_count
        middle += val.middle_level_count
        low += val.low_level_count
        total += val.total_count
      }
      const highPercent = parseFloat(high / total)
      const middlePercent = parseFloat(middle / total)
      // const lowPercent = parseFloat(low_level_count / total_count);
      const lowPercent = (1 - highPercent - middlePercent)
      myDataCoord.push(
        {
          item: '高风险',
          percent: highPercent
        }
      )
      myDataCoord.push(
        {
          item: '中风险',
          percent: middlePercent
        }
      )
      myDataCoord.push(
        {
          item: '低风险',
          percent: lowPercent
        }
      )
      console.log(myData)
      this.data = myData
      this.dataCoord = myDataCoord
      this.loading = false
      this.tag = false
    }
  },
  computed: {
    getList () {
      const data = []
      this.$store.state.product.map(val => {
        if (val.busi === 'antifraud_online') {
          const arr = this.list.filter(value => value.value === val.busi)
          data.push(...arr)
          if (this.$route.params.busi) {
            this.type = this.$route.params.busi
          } else if (data.length > 0) {
            this.type = data[0].value
          }
        }
      })
      return data
    },
    selectName () {
      return this.getList.find(val => val.value === this.type).label
    }
  }
}
</script>

<style scoped src="./zhb.scss" lang="scss"></style>
<style scoped>
.pTable tbody tr td {
  height: 118px;
  line-height: 118px;
}
.haveZhb .haveZhb_tip {
  text-align: center;
  font-size: 14px;
  line-height: 20px;
}
</style>
<style>
.fp .el-tabs__nav-wrap::after {
  background-color: transparent;
}

.fp .el-tabs__item {
  color: rgba(111, 118, 140, 1);
  font-weight: 500;
  font-size: 18px;
}

.fp .el-tabs__item.is-active {
  color: #003d92;
}

.fp .el-tabs__item:hover {
  color: #003d92;
  cursor: pointer;
}

.fp .el-tabs__header {
  margin-top: 22px;
  margin-bottom: 20px;
}
</style>
